import { Loader, LoaderType } from '@progress/kendo-react-indicators';
import React from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';
import { useGlobalizationContext } from '../../context/globalization/GlobalizationContext';
import { useTranslation } from '../../context/globalization/useTranslation';

interface GearLoaderProps {
  type?: LoaderType;
  textMessageKey?: string;
}

const GearLoader: React.FC<GearLoaderProps> = props => {
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);

  return (
    <Dialog className={`gearLoader ${!props.textMessageKey ? 'gearLoader--no-background' : ''}`}>
      <Loader size="large" type={props.type || 'converging-spinner'} />
      {props.textMessageKey && <div className="gearLoaderText">{translate(props.textMessageKey)}</div>}
    </Dialog>
  );
};

export default GearLoader;
